module.exports = __webpack_public_path__ + "static/img/05.內部稽核組織.7df91f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/05.內部稽核組織.jpg
// module id = Tojl
// module chunks = 1